import { render, staticRenderFns } from "./TabContentPlan.vue?vue&type=template&id=38793174&scoped=true&"
import script from "./TabContentPlan.vue?vue&type=script&lang=js&"
export * from "./TabContentPlan.vue?vue&type=script&lang=js&"
import style0 from "./TabContentPlan.vue?vue&type=style&index=0&id=38793174&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38793174",
  null
  
)

export default component.exports